import { Link as RouterLink } from 'react-router-dom';
import {
    Breadcrumbs,
    Box,
    Grid,
    IconButton,
    Link,
    Toolbar,
    Tooltip,
    Typography,
    Tab,
    Tabs,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack } from '@material-ui/icons';
import { useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';
import ManageDevices from './Components/Devices';
import Billing from './Components/Billing';
import { host, enableBilling } from "../../data";
import BranchesNavigationButton from "../Components/BranchNavigationButton";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    indented: {
        marginLeft: theme.spacing(10),
    },
    content: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    content_nav: {
        padding: theme.spacing(1),
    },
    grow: {
        flexGrow: 1,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    formControlLabel: {
        marginLeft: theme.spacing(2),
    },
    rootpaper: {
        width: 1000,
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        overflowX: "auto"
    },
    table: {
        width: 1000
    },
    breadcrumbFontSize: {
        [theme.breakpoints.down('xs')]: {
            fontSize: '1rem'
        }
    },
    arrowBack: {
        [theme.breakpoints.down('xs')]: {
            padding: '5px',
            marginRight: '7px'
        }
    },
    tabsWrap: {
        padding: '0 8px'
    }
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={1}>
                    {children}
                </Box>
            )}
        </div>
    );
}

export default function OrgBilling({ orgInfo }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const [devices, setDevices] = useState([]);
    const [value, setValue] = useState(0);
    const [branches, setBranches] = useState([]);
    const [seconds, setSeconds] = useState(0);
    const [updateDeviceStatus, setUpdateDeviceStatus] = useState(false);

    useEffect(() => {
        fetchBranchData();
    }, [orgInfo]);

    function fetchBranchData() {
        Auth.currentAuthenticatedUser()
            .then(data => {
                var requestOptions = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': data.signInUserSession.idToken.jwtToken
                    }
                };

                fetch(host + '/orgs/' + orgInfo.orgId
                    + '/branches', requestOptions)
                    .then(results => results.json())
                    .then(data => {
                        // If no branch exists, send the user to the branch creation page.
                        setBranches(
                            data.data.branchesList
                        );
                    }).catch((error) => {
                        console.log(error);
                    });
            });
    }

    function handleSetDevices(data_in) {
        var lDevices = JSON.parse(JSON.stringify(data_in));
        var i;
        var deviceStatusInProcess = false;
        function compare ( a, b) {
            //console.log(a.ServerTime);
            //console.log(b.ServerTime);
            if (!a.ServerTime){
                return 1;
            }
            if (!b.ServerTime){
                return -1;
            }
            if ( a.ServerTime < b.ServerTime){
                return 1;
            }
            if ( a.ServerTime > b.ServerTime){
                return -1;
            }
            return 0
        }

        for (i = 0; i < lDevices.length; i++) {
            lDevices[i]['id'] = lDevices[i]['uid'];
            if (lDevices[i].status === 3) {
                deviceStatusInProcess = true;
                setSeconds(60);
            }
            if (lDevices[i].ServerTime) {                
                lDevices[i].ServerTime_UTC = new Date(lDevices[i].ServerTime);
            }
        }
        lDevices.sort(compare);
        setDevices(lDevices);
        setUpdateDeviceStatus(deviceStatusInProcess);
    }

    function fetchDevices() {
        Auth.currentAuthenticatedUser()
            .then(data => {
                var requestOptions = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': data.signInUserSession.idToken.jwtToken
                    },
                };

                fetch(host + '/orgs/' + orgInfo.orgId + '/devices/', requestOptions)
                    .then(results => results.json())
                    .then(data => {
                        handleSetDevices(data.deviceList);
                    }).catch((error) => {
                        console.log(error)
                    })
            });
    }

    useEffect(() => {
        if (seconds > 0) {
            setTimeout(() => setSeconds(seconds - 1), 1000);
        } else {
            if (updateDeviceStatus) {
                fetchDevices();
            }
        }
    });

    useEffect(() => {
        fetchDevices();
    }, [orgInfo]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Grid container
            direction='column'
            justify='flex-start'
            alignItems='stretch'
            className={classes.content}>
            <Grid item xs>
                <Toolbar>
                    <Tooltip title={t("goHome")}>
                        <IconButton color='primary'
                            className={classes.arrowBack}
                            component={RouterLink}
                            to={'/'}>
                            <ArrowBack />
                        </IconButton>
                    </Tooltip>
                    <Breadcrumbs>
                        <Link
                            className={classes.breadcrumbFontSize}
                            variant='h5'
                            component={RouterLink}
                            to={'/'}
                        >
                            {t("settings")}
                        </Link>
                        <Typography
                            className={classes.breadcrumbFontSize}
                            variant="h5"
                        >
                            {t("deviceBilling")}
                        </Typography>
                    </Breadcrumbs>
                    <div className={classes.content_nav} />
                    <BranchesNavigationButton text={t("branches_caps")} orgInfo={orgInfo} branchesList={branches} />
                </Toolbar>
            </Grid>
            <Grid item xs>
                <Tabs className={classes.tabsWrap} value={value}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={handleChange}>
                    <Tab label={t("devices_caps")} />
                    <Tab label={t("billing_caps")} />
                </Tabs>
                <TabPanel value={value} index={0}>
                    <ManageDevices
                        orgInfo={orgInfo}
                        devices={devices}
                        setDevices={handleSetDevices}
                        fetchDevices={fetchDevices}
                    />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    {enableBilling ? <Billing /> :
                        <Typography>Under construction.</Typography>}
                </TabPanel>
            </Grid>
        </Grid>
    )
}
